module.exports = __webpack_public_path__ + "static/media/smoke-background_smaller.8fc73353.png";